import { format } from 'date-fns';
import { MONTH_PASCAL } from '../../constants';

const getMonthName = (month: number): MONTH_PASCAL => {
  const date = new Date();
  date.setMonth(month - 1, 1);
  return format(new Date(date), 'MMMM') as MONTH_PASCAL;
};

export default getMonthName;
